const isProd = process.env.NODE_ENV === 'production'

export const firebaseConfig = {
  apiKey: "AIzaSyD0Nm4DxZkj79mgoeaTczXA9GnrrURntw0",
  authDomain: "hr-lms-5cb30.firebaseapp.com",
  databaseURL: "https://hr-lms-5cb30.firebaseio.com",
  projectId: "hr-lms-5cb30",
  storageBucket: "hr-lms-5cb30.appspot.com",
  // messagingSenderId: "729444454592",
  appId: "1:729444454592:web:a310c0705343e39f0f5d25",
  measurementId: "G-HZWWP110J3"
}

const bases = {
  g9Archive: 'appBVp8sxaqI2NZ6j',
  voxTest: 'appqgLT9e1fFH2g09',
  voxProd: 'app3aTwfl8knclNjm'
}

const sessionTables = {
  g9Archive: 'tblYxHT01ryxCEEpd',
  voxTest: 'tbltO6BOkiUyAiax7',
  voxProd: 'tblqMbhNPpscMcsCg'
}

export const airtableConfig = {
  base: isProd ? bases.voxProd : bases.voxTest,
  sessionTable: isProd ? sessionTables.voxProd : sessionTables.voxProd
}

export const isUsingProdData = airtableConfig.base === bases.voxProd;

export const shortLinkConfig = {
  // shortIoPublicKey: '0pu8KDdIVjSHZxmQ1lWGaRrOVivJR25s'
  shortIoPublicKey: 'pk_rwLWn8k9i2UFdst2'
}

export const environment = {
  isProd: process.env.NODE_ENV === 'production'
}